// 塞尔维亚语
import constant from '../../constants/lang/sr';
import newLang from '../newLang/sr';
/* eslint-disable max-len */
export default {
  cfmoto: {
    ...(newLang.cfmoto || {}),
    constant,
    api: {
      http: {
        401: 'Molim vas, prijavite se prvi',
        404: 'Nema podataka',
        500: 'Sistem je zauzet, pokušajte ponovo kasnije',
        504: 'Vreme zahteva je odmišljeno',
        ERR_NETWORK: 'Izuzev mreže',
        ERR_NETWORK_UPLOAD: 'Отпремање није успело, покушајте на другој мрежи',
      },
    },
    title: '智能网联国际版管理后台',
    navbar: {
      dropdown: {
        updatePassword: '修改密码',
        switchLanguage: '切换语言',
        logout: '退出登录',
      },
    },
    router: {
      title: {
        'binding-agreement': '绑车协议',
        introduce: '介绍',
        lamp: 'индикаторска лампица',
        download: 'CFMOTO RIDE APP Download',
        orderConfirm: 'Order Confirmation',
        ebook: 'ebook',
        list: 'ebook',
        pdf: 'PDF',
        feedback: 'Рецордс',
        'feedback-create': 'Vraćanje',
        'feedback-supplement': 'Допълни отговор',
        'feedback-detail': 'Detalji povratka',
        'feedback-result': 'Vraćanje',
        guide: 'Центар за помоћ',
        'guide-restScreen': 'Uputstva za instalaciju',
        'guide-overview': 'Pregled funkcija',
        'guide-account': 'O nalogu',
        'guide-vehicle': 'O vozilu',
        'guide-meterSetting': 'Kako podesiti kontrolnu tablu',
        'guide-vehicleSetting': 'Kako postaviti vozilo',
        'guide-findNavigation': 'Kako se kretati da biste pronašli vozilo',
        'guide-vehicleNnavigation': 'Kako koristiti navigaciju',
        'guide-cyclingRecord': 'O istoriji vožnje',
        'guide-vehicleExperience': 'Kako izvršiti samopregled vozila',
        'guide-useSetting': 'Kako napraviti opće postavke APP-a',
        'guide-notice': 'Kako pregledati i postaviti obavijest o poruci',
        'guide-about': 'O APP-u',
        help: 'Pomoæ & Vraćanje',
        'help-detail': 'Detalji pitanja',
        'myCar-unbinding': 'Primeni poništavanje',
        'myCar-unbinding-result': 'Primeni poništavanje',
      },
    },
    form: {
      cancel: 'Отмени',
      confirm: 'Potvrdi',
      submit: 'Подај',
      search: 'Тражи',
      language: {
        languageCode: {
          label: '请选择语言：',
          placeholder: '请选择语言',
        },
      },
    },
    rules: {
      language: {
        languageCode: {
          required: '请选择语言',
        },
      },
    },
    dialog: {
      language: '语言选择',
    },
    binding: {
      title: `Protokol`,
      text1: '1.	Телематицс Сервицес',
      text2:
        'ЦФМОТО Поверспортс, Инц. (у даљем тексту „ ЦФМОТО “ ) пружа услуге телематике возила купцу који је купио ЦФМОТО возило (у даљем тексту „Купац“ ). За ове услуге, ЦФМОТО користи податке снимљене од стране возила о возилу и његовом понашању у вожњи у релевантном временском периоду. Детаљније, ово се односи на следеће податке:',
      text3: 'Подаци о понашању корисника у вожњи : укључујући убрзање, успоравање, брзину, савијање, последње време вожње и последњу километражу .',
      text4:
        'Подаци о статусу возила: односе се на статус возила у реалном времену, укључујући режим вожње, преостало гориво, тренутну економичност горива, километражу, брзину возила у реалном времену, брзину мотора, притисак у гумама, температуру пнеуматика, податке о напону активирања батерије , температура расхладне течности, статус електронског закључавања, верзија софтвера интелигентног уређаја, јачина сигнала паметних уређаја, тренутна поставка контролне табле.',
      text5:
        'Подаци о аларму возила: подаци о аларму који се шаљу ако одређени подаци премашују унапред подешену вредност, као што су температура мотора, превелика брзина, прекомерно време вожње, висока температура расхладне течности, ненормално кретање возила, ненормалан притисак у гумама, вибрације, испуштање, судар итд . .',
      text6: 'Информације о грешци возила: односи се на кодове грешака које извештава сваки унутрашњи део возила.',
      text7: 'Подаци о локацији возила: односе се на специфично географско боравиште возила.',
      text8: '1.1.	Провид инг Клијент са услугама у вези са возилом преко ЦФМОТО РИДЕ АПП .',
      text9: '1.1.1.	Потрошачи могу даљински управљати возилима преко ЦФМОТО РИДЕ АПП (укључујући преглед локације возила, подешавање информација о возилу и функција, даљинско управљање статусом возила, итд.).',
      text10: '1.1.2.	Пружање планирања руте током навигације, укључујући израчунавање удаљености између возила и пјешачку навигацију у сврху проналажења возила .',
      text11: '1.2.	Слање потребних обавештења Купцу на основу стања возила.',
      text12: '1.2.1.	ЦФМОТО ће прекинути обавештења Купца о одржавању возила (нпр. на основу укупне удаљености коју је корисник прешао, времена када је купац купио возило, захтеваног времена или удаљености вожње за одржавање возила) .',
      text13: '1.2.2.	На основу података о возилу , ЦФМОТО ће купцу слати обавештења о ненормалној ситуацији; укључујући анализу података од стране ОЕМ (у зависности од модела) за пружање бриге о купцима и накнадну оптимизацију возила .',
      text14: '1.3.	Подршка у анализи узрока незгоде уколико Купац пријави тешку незгоду Возила.',
      text15:
        '1.3.1.	У случају озбиљног удеса возила, као што је када се возило преврне или преврне на бок током вожње, ЦФМОТО ће подржати Купца на захтев да разјасни да ли је до незгоде дошло због квара на возилу или других околности. Купац подноси захтев ЦФМОТО-у преко локалног дистрибутера / продајног партнера наведеног у Уговору о продаји возила.',
      text16: '1.3.2.	У мери у којој доступни подаци то дозвољавају, ЦФМОТО ће проценити податке у односу на узрок несреће и доставити Клијенту одговарајући извештај.',
      text17: '1.4.	Помоћ Купцу да поврати Возило након губитка Возила .',
      text18: '1.4.1.	Ако се возило изгуби, ЦФМОТО ће клијенту доставити податке о локацији возила и друге корисне податке о статусу возила (као што је локација последње активације, тренутни статус возила, итд.) на захтев и ако су доступни.',
      text19: '1.4.2.	Купац подноси захтев ЦФМОТО-у преко локалног дистрибутера / продајног партнера наведеног у Уговору о продаји возила.',
      text20: '1.5.	Пријављивање проблема након продаје .',
      text21: '1.5.1.	ЦФМОТО прикупља даљински обавештења о кодовима грешке које возило шаље у случају квара његових компоненти и пружа одговарајуће информације на захтев Купца директно Купцу.',
      text22: '1.5.2.	Купац подноси захтев ЦФМОТО-у преко локалног дистрибутера / продајног партнера наведеног у Уговору о продаји возила.',
      text23: '2.	Ограничења и искључења услуге',
      text24: '2.1.	Изричито се истиче да структурне или друге техничке промене на возилу могу ограничити пружање услуга или чак онемогућити, јер услуге зависе од тачности података о возилу.',
      text25: '2.2.	Тамо где се такве услуге не могу пружити због перформанси било које треће стране података или телекомуникационих мрежа, било каква одговорност ЦФМОТО-а је искључена.',
      text26: '3.	Приватност',
      text27:
        'ЦФМОТО ће се придржавати важећих прописа о заштити података када обрађује личне податке у вези са ЦФМОТО возилом . Услови политике приватности Ц ФМОТО -а наведени су у овој ЦФМОТО РИДЕ АПП. Као додатак политици приватности , његово обавештење је у складу са политиком приватности . Клијент се може позвати на политику приватности за неке садржаје који се односе на обраду података који нису обухваћени овим обавештењем.',
      text28: '4.	Кориснички сервис',
      text29:
        '4.1.	Клијент може слободно да пошаље питања, коментаре или недоумице у вези са приватношћу на ЦФМОТОРИДЕАПП@цфмотоуса.цом или да пише на: ЦФМОТО Поверспортс, Инц., 3555 Холли Лане Нортх, Суите 30, Плимоутх, М Н 55447. Корисник такође може позвати ЦФМОТО Односи са клијентима на (888) 823-6686. ',
      text30: '5.	Р евисионс',
      text31: '5.1.	ЦФМОТО задржава право да промени ово обавештење у било ком тренутку, али ћемо објавити ревизије на ЦФМОТО РИДЕ Апликација и/или дајте обавештење пре него што то учинимо по потреби.',
    },

    atmosphere: {
      desTitle: '功能说明',
      setINfo: 'Нова подешавања ће ступити на снагу у року од 1-3 минута након што се возило укључи, уверите се да је возило у добром сигналном положају',
      setSuccess: 'Постанови успешно',
      sure: 'Siguran',
      confirm: 'Potvrdi',
      cancel: 'Отмени',
      cContent: 'Подешавања још увек нису сачувана, да ли желите да их сачувате?',
      save: 'Сачувај подешавања',
      introduce1: 'Близу упутства за аутоматско откључавање',
      introduce2: 'упутства за аутоматско искључивање',
      introduce3: 'Упутства за аутоматско буђење',
      introduce4: 'Одложено гашење светла',
      content1: {
        msg1: 'Након што се функција укључи, мобилни телефон укључује Блуетоотх и АПП наставља да ради. Када се возило приближава издалека у близину, возило се може аутоматски откључати и укључити.',
        msg2: 'Ако обично није откључан и укључен, притисните дугме за напајање возила да бисте откључали и укључили',
        msg3: 'Аутоматско откључавање близине ће се покренути само једном пре него што се Блуетоотх искључи',
      },
      content2: {
        msg1: 'Након што је функција укључена, возило ће се аутоматски искључити након 5 секунди након три услова возила које се искључује, брзина возила је 0 и храм је пао',
        msg2: 'Покретање возила током периода аутоматског искључивања, брзина возила није 0, или је храм одложен ће отказати аутоматско искључивање',
      },
      content3: {
        msg1: 'Након укључења функције, када је возило искључено, мобилни телефон укључује Блуетоотх и АПП наставља да ради или носи физички кључ. Када се приближавате возилу од далека до близине, светла возила ће трептати да дочекају госте',
        msg2: 'Да би се спречило да чести окидачи изазивају губитак снаге возила, након што се функција добродошлице покрене два пута у року од 30 секунди, неће се наставити до 30 минута касније',
      },
      content4: {
        msg1: 'Након што се функција укључи, дуга и кратка светла ће се аутоматски укључити 10 секунди након што се возило искључи',
      },
    },
    feedback: {
      label: {
        type: 'Тип повратне информације (један избор)',
        content: 'Описане проблема',
        fileList: 'Molim vas, dodajte slike',
        fileList2: '(Do 4 slika/1 video)',
        feedbackCreate: 'Kliknite da se javite',
        feedbackSupplement: 'Допълни отговор',
        backHome: 'Vratimo se kući',
        vehicle: 'повезано возило',
        selectVehicle: 'изаберите возило',
      },
      placeholder: {
        'content.bug': 'Molim vas, opisite detaljno vrijeme događaja, APP verzije, model mobilnog telefona, putem operacije i opis problema kako bi brzo pomogli pronaći i zabrinuti problem!',
        'content.suggest': 'Dobrodošli dati vrijedne predloge, ozbiljno ćemo razmotriti vaše ideje.',
        'content.vehicle': 'Molim vas opisite vrijeme događaja, putem operacije i opis problema',
        'content.other': 'Molim vas opisite vrijeme događaja, putem operacije i opis problema',
        'content.supplement': 'Додајте опис проблема',
        vehicle: 'Молимо изаберите возило',
      },
      rules: {
        'type.required': 'Изаберите тип повратних информација',
        'content.required': 'Molim vas, uvedite opis problema.',
        'fileList.uploading': 'Отпремање, сачекајте',
        'fileList.maxSize': 'Превише је изношен фајл',
        'fileList.overType': 'Неподкрепан формат',
        'fileList.maxCount': 'Količina postavljanja prelazi granicu',
        'fileList.acceptImageVideo': 'Video se ne može odabrati kada birate sliku',
        'vehicle.required': 'Молимо изаберите возило',
      },
      message: {
        empty: 'Trenutno nema snimka povratka',
        finish: 'Molim vas, uvedite opis problema.',
        loading: 'Влађавање',
        uploadFailed: 'Изплатање неуспешно',
        tip: 'Da biste zaštitili sigurnost vašeg računa, molim vas, ne podajte osjetljive osobne informacije ovde, kao što je lozinka, itd.',
        feedbackSuccess: 'Primljena povratka',
        'submit.error': 'Vraæanje nije uspjelo',
        'submit.success': 'Primljena povratka',
      },
    },
    guide: {
      label: { giveFeedback: 'Non soluta, respondere volo' },
    },
    help: {
      label: {
        history: 'Pretražite zapise',
        cancel: 'Отмени',
        yes: 'Da.',
        no: 'Ne, ne.',
        unresolved: 'Još uvek ne možete da rešite? Kliknite',
        submitFeedback: 'Pošaljite povratne informacije',
      },
      placeholder: {
        search: 'Тражи',
        'content.required': 'Molim vas, uvedite ključnu reè',
      },
      message: {
        empty: 'Nema povezanog sadržaja',
        empty2: 'Predložite promenu ključnih reči ili',
        finish: 'Molim vas, uvedite opis problema.',
        historyDelete: 'Izbrisati sve zapise pretrage?',
        isHelpful: 'Da li to pomaže?',
      },
    },
    unbinding: {
      label: {
        vin: 'VIN',
        realName: 'Ваше име и презиме',
        email: 'E-adresa',
        phone: 'Telefonski broj',
        areaCode: 'Državni pozivni broj',
        identity: 'Identifikacija',
        drivingLicense: 'Potvrda o registraciji vozila.',
        backHome: 'Vratimo se kući.',
        areaCodeTitle: 'Pozivni broj zemlje',
        latterTitle: 'Објава',
        agree: 'Priznajem.',
        disagree: 'Sloћila',
        agreeCheckLabel: 'Èitao sam i složio se.',
        agreeCheckTitle: 'Obaveza zahteva za odjavu vozila.',
      },
      placeholder: {
        vin: 'Unesite VIN',
        realName: 'Unesite svoje pravo ime',
        email: 'Molimo, unesite vašu i-mejl adresu',
        phone: 'Unesite Vaš broj telefona',
        identity: 'Glavna stranica lične karte, vozačke dozvole ili pasoša koja sadrži lične identifikacione podatke.',
        drivingLicense: 'Glavna stranica potvrde o registraciji vozila sa imenom vlasnika i brojem šasije (VIN).',
      },
      rules: {
        'agree.required': 'Molim vas pročitajte i složite se',
        'vin.required': 'Unesite VIN',
        'vin.pattern': 'Pogrešan VIN, molim proverite.',
        'realName.required': 'Unesite svoje pravo ime',
        'email.required': 'Molimo, unesite vašu i-mejl adresu',
        'email.pattern': 'Format adrese elektronske pošte je pogrešan, molim proverite.',
        'phone.required': 'Unesite Vaš broj telefona',
        'phone.pattern': 'Greška u formatu telefonskog broja, proverite',
        'fileList.maxCount': 'Količina postavljanja prelazi granicu',
        'fileList.uploading': 'Отпремање, сачекајте',
      },
      message: {
        imgUploadFailed: 'Укачање фотографије неуспело',
        securityMessage: 'Gornje informacije se koriste samo u svrhu provere identiteta, CFMOTO čuva vaše podatke.',
        resultMessage: 'Проверићемо материјале за пријаву што је пре могуће, обратите пажњу на траку са обавештењима или АПП центар за поруке на време.',
        loading: 'Влађавање',
      },
    },
  },
};
